import React from "react";
import {Grid} from "@leap4/frontend";
import {EntitiesProperties} from "../../../utils/enums";
import {SingleMetric} from "../../common/OverviewGeneralInfo/SingleMetric";
import {IMetricsTotals, IOverviewData} from "../../../interfaces/IOverviewData";

export interface IHomePageGeneralInfoProps {
    data: IMetricsTotals
}

export const HomeGeneralInfo = ({data}: IHomePageGeneralInfoProps): JSX.Element => {
    const {COST, IMPRESSIONS, REQUESTS, FILL_RATE, CPM} = EntitiesProperties.NUMERIC.ALL
    const constantGap = '10px'

    const metricEnumKeyMap = {
        impressions: IMPRESSIONS,
        requests: REQUESTS,
        fillRate: FILL_RATE,
        cost: COST,
        cpm: CPM
    }
    return (
        <Grid container direction={"row"} justifyContent={"space-evenly"} alignItems={"center"} sx={{ py: 0.5, px: 2 }}>
            {Object.entries(data ? data : {})?.map(([metricKey, metricValue]) => {
                return (
                    <Grid key={metricKey} sx={{ textAlign: 'center', flex: 1 }}>
                        <SingleMetric
                            metricValue={metricValue as number} metricEnum={metricEnumKeyMap[metricKey]}
                        />
                    </Grid>
                )
            })}
        </Grid>
    )
}

